import React, { FC, CSSProperties } from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { LanguageIcon } from '~/img';
import { Languages } from '~/layout/Header/Profile';
import { useDirection } from '~/hooks';

interface Props {
  className?: string;
}

const ChangeLanguage: FC<Props> = (props) => {
  const { className } = props;
  const [direction] = useDirection();

  return (
    <div className={className} style={getPostion(direction)}>
      <Dropdown overlay={<Overlay {...props} />} placement="bottomRight" arrow>
        <Button shape="circle" icon={<LanguageIcon />} />
      </Dropdown>
    </div>
  );
};

const Overlay: FC = () => {
  const { i18n } = useTranslation();

  const handleMenuItemClick = ({ key }: any) => {
    void i18n.changeLanguage(key);
  };

  return (
    <Menu
      mode="inline"
      selectedKeys={[i18n.language]}
      selectable={false}
      onClick={handleMenuItemClick}
      className="menu-shadow"
    >
      {Languages()}
    </Menu>
  );
};

const getPostion = (d: 'rtl' | 'ltr'): CSSProperties => {
  switch (d) {
    case 'rtl':
      return { left: 24 };
    default:
      return { right: 24 };
  }
};

export default styled(ChangeLanguage)`
  display: flex;
  position: fixed;
  z-index: 1;
  top: 24px;
`;
